"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { useState, useEffect, useMemo, useTransition } from "react"
import get from "lodash/get"
import debounce from "lodash/debounce"
import SignUpLoginHeader from "../../../pages/loginAndSignUp/shared/SignUpLoginHeader"
import ColorButton from "../../../pages/loginAndSignUp/shared/ColorButton"
import TextField from "@mui/material/TextField"
import SecondaryLinkContainer from "../../../pages/loginAndSignUp/shared/SecondaryLinkContainer"
import updateSuccessMessage from "../../../../graphql/mutations/snackbarMessage/updateSuccessMessage"
import updateErrorMessage from "../../../../graphql/mutations/snackbarMessage/updateErrorMessage"
import updateWarningMessage from "../../../../graphql/mutations/snackbarMessage/updateWarningMessage"
import { useRouter, useSearchParams } from "next/navigation"
import { signUpEmailVar } from "../../../../graphql/reactiveVars"
import getAllUrlParams from "../../../../lib/url/getAllUrlParams"
import Loader from "../../Loader"
import { useReactiveVar } from "@apollo/client/react"
import { forgotPassword, resendSignUpCode } from "../../../../lib/auth/authActions"
const UNVERIFIED_EMAIL =
  "Cannot reset password for the user as there is no registered/verified email or phone_number"
export default function ForgotPassword() {
  const router = useRouter()
  const signUpEmail = useReactiveVar(signUpEmailVar) as string
  const searchParams = useSearchParams()
  const allUrlParms = getAllUrlParams(searchParams)
  const cohortIdParam = searchParams.get("cohort_id")
  const [email, setEmail] = useState(signUpEmail)
  const [isPending, startTransition] = useTransition()

  const hrefLogin = allUrlParms ? `/login?${allUrlParms}` : "/login"

  const onClose = () => {
    // do nothing
  }

  // Update the debouncedHandleSendResetPassword to use startTransition
  const debouncedHandleSendResetPassword = useMemo(
    () =>
      debounce(async () => {
        try {
          startTransition(async () => {
            // todo: forgot password should carry over checkoutId if it exists
            const result = await forgotPassword(email)
            if (result.success) {
              updateSuccessMessage(`Reset password email sent.`)
              router.push(allUrlParms ? `/?${allUrlParms}` : "/")
            } else {
              updateErrorMessage(result?.message)
            }
          })
        } catch (error) {
          const errorMsg = get(
            error,
            "message",
            "Error sending reset password. Please try again.",
          )
          // if the email is not verified:
          // send them to the confirmation email
          // move them to the screen to confirm their email
          if (errorMsg === UNVERIFIED_EMAIL) {
            try {
              const result = await resendSignUpCode(email)
              if (result.success) {
                signUpEmailVar(email)
                updateWarningMessage(
                  "Please verify your email. Then login or reset password.",
                )
                router.push(
                  allUrlParms
                    ? `/signup/confirm-email?${allUrlParms}`
                    : "/signup/confirm-email",
                )
              } else {
                updateErrorMessage({
                  message: get(
                    result,
                    "message",
                    "Error occured. Please try again.",
                  ),
                  trackToSentry: true,
                })
              }
            } catch (confirmationError) {
              updateErrorMessage({
                message:
                  "Please contact support. Cannot reset password or resend confirmation code.",
                trackToSentry: true,
                error: confirmationError,
              })
            }
          } else {
            updateErrorMessage({ message: errorMsg, trackToSentry: true, error })
          }
        }
      }, 300),
    [email, router, allUrlParms],
  )

  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault()
        debouncedHandleSendResetPassword()
      }
    }
    document.addEventListener("keydown", listener)
    return () => {
      document.removeEventListener("keydown", listener)
    }
  }, [debouncedHandleSendResetPassword])

  const handleTextUpdate = (
    name: string,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    if (name == "email") {
      setEmail(event.target.value)
    }
  }

  return [
    <div
      className={
        "flex flex-col items-center justify-center w-full max-w-[500px] font-roboto"
      }
      key={"text-side-forgot-pw"}
    >
      <div className={``}>
        <SignUpLoginHeader text={"Forgot password?"} />
      </div>
      <div className={""}>
        Enter the email address associated with your account, and we'll email you a
        link to reset your password.
      </div>

      <TextField
        id="outlined-disabled"
        label="Email"
        type="email"
        variant="outlined"
        fullWidth={true}
        onChange={(event) => {
          return handleTextUpdate("email", event)
        }}
        sx={{ maxWidth: "308px", marginTop: "20px" }}
      />

      <div className={"my-[20px] w-full flex justify-center"}>
        <ColorButton
          onClick={() => {
            return debouncedHandleSendResetPassword()
          }}
          variant="contained"
          color="primary"
        >
          Send Reset Link
        </ColorButton>
      </div>
      <SecondaryLinkContainer href={hrefLogin} text={"Log in?"} />
    </div>,
    isPending ? <Loader handleOnClick={() => {}} key={"loader"} /> : null,
  ]
}
